import get from 'lodash/get';
import rfc from 'react-fast-compare';
import { useSelector } from 'react-redux';
import { reducerName } from './rootReducer';

const getters = (st, fieldName = '') => ({
  gs: (path = '', def = undefined) =>
    get(st, `${reducerName}${fieldName ? `.${fieldName}` : ''}${path ? `.${path}` : path}`, def),
});
const us = (cb) =>
  useSelector((state) => {
    const { gs } = getters(state);
    return cb(gs, state);
  }, rfc);

export const selectGrowls = () => us((gs) => gs('growls', {}));

export const selectCmsBaseUrl = () =>
  us((gs) => {
    const base = window.location.origin || gs(`config.cmsBaseUrl`, '');
    return base?.endsWith('/') ? base : `${base}/`;
  });

export const selectGroupGrowls = (groupId) => us((gs) => gs(`growls.${groupId}`, []));

export const selectNav = () => us((gs) => gs('navigation', {}));

export const selectConfig = () => us((gs) => gs('config', {}));
export const selectMapConfig = () => us((gs) => gs('config.mapConfig', {}));
export const selectIsServiceConfigured = (serviceName) =>
  us((gs) => gs('config.plugins', [])?.includes(serviceName));
export const selectTrackBooksServer = () => us((gs) => !!gs('config.trackBooksServer'));

export const selectSsoLinksConfig = (state) => {
  const ssoLinks = state?.root?.config?.ssoLinks;
  return {
    enabled: !!ssoLinks?.enabled,
    siteName: ssoLinks?.siteName || '',
  };
};
export const selectNewsletterEnabled = (state) => !!state?.root?.config?.newsletterEnabled;

export const selectUserEmail = (state) => state?.root?.config?.loggedInUser?.email;
export const selectIsSuperAdmin = (state) => state?.root?.config?.role === 'super_admin';
export const selectRole = (state) => state?.root?.config?.role;
export const selectShowAccessCode = (state) =>
  state?.root?.config?.userConfig?.editableAccessCode || false;
export const selectHasPrivileges = (privilege) => (state) => {
  const { role, privileges = [] } = state?.root?.config || {};
  if (typeof privilege === 'string') {
    return role === 'super_admin' || privileges.includes(privilege);
  } else if (Array.isArray(privilege)) {
    return privilege.map((p) => role === 'super_admin' || privileges.includes(p));
  }
  return false;
};

export const selectAppUserSettings = (state) => {
  const {
    allowAppUsersCustomAuth,
    allowAppUsersImport,
    denyAdditionalCustomFields,
    emailNotRequired,
    externalSourceOfTruth,
    role,
  } = state?.root?.config || {};
  return {
    allowAdditionalFields: !denyAdditionalCustomFields && role === 'super_admin',
    allowAppUsersCustomAuth,
    allowAppUsersImport,
    emailNotRequired,
    externalSourceOfTruth,
    requireEmailForImport: role !== 'super_admin',
  };
};
